export const environment = {
  production: false,
  app: {
    name: 'RED LABORAL',
    version: '1.0.0'
  },
  api: {
    url: 'api'
  },
  googleMaps: {
    apiKey: 'AIzaSyCm1VhsBHm6pijpevujrHTnWfWwOQ5ELr0',
    libraries: 'places'
  }
};
